import setCurrentPage from "src/Utils/setCurrentPage";

const LIST_DATA_BENEFITS_TEMPLATE = [
  {
    icon: "gearWithCircuits2",
    iconColor: "white",
    text: "Capture number of jobs in \na specific wirecenter​",
    listItemCustomStyle: { width: "400px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
  {
    icon: "cloudLikeSun",
    iconColor: "white",
    text: "Evenly distribute techs per area \nwhen grouping the wirecenters",
    listItemCustomStyle: { width: "400px" },
    textCustomStyle: { fontSize: "24px", letterSpacing: "0.24px" },
  },
];

export const DATA_BENEFITS_TO_2 = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: "reduce overutilization of technicians",
  titleNumber: "2.",
  text: "Revolutionize Workload Distribution: Significantly minimize \noverutilization and underutilization of technicians with Infosys \ntechnology. Experience a more equitable distribution of jobs per \ntechnician and per area, ensuring optimal efficiency across your \noperations.",
  listData: LIST_DATA_BENEFITS_TEMPLATE,
  next: {
    label: "Challenges Solved",
    onClick: () => setCurrentPage(404),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(402),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "TURF_OPTIMIZATION/TO_bg_3.png",
};
